module.exports = __webpack_public_path__ + "img/file-tray-full-outline.e5251433.svg";